export enum MainPageActions {
  ACCOUNT = 'ACCOUNT',
  PASSWORD = 'PASSWORD',
  NOTIFICATIONS = 'NOTIFICATIONS',
  LOGOUT = 'LOGOUT',
  LOGIN = 'LOGIN',
  HOME_PAGE = 'HOME_PAGE',
  NEW_TURNOVER = 'NEW_TURNOVER',
}
